<script setup>
/**
 * Table data cell for use in custom body rows inside HrTable.
 *
 * @status recommended
 * @group lists-tables
 * @useWhen Rendering a custom data cell in a table built with HrTable
 * @within hr-table
 * @see https://quasar.dev/vue-components/table Quasar q-td API
 */
// inheritAttrs: false because the template spreads $attrs onto the q-td itself. Without it
// Vue's own fallthrough applies them a second time.
defineOptions({ name: 'HrTd', inheritAttrs: false });

const props = defineProps({
  /**
   * The column this cell belongs to, by name.
   *
   * Quasar resolves a cell's column from its own vnode key, and `key` is consumed by Vue on THIS
   * component rather than passed down — so without it a cell in a custom header or body row cannot
   * find its column. QTh throws reading `sortable` off nothing; QTd renders an empty cell and says
   * nothing at all. Set it to `col.name` alongside the `:key` the v-for needs.
   */
  columnName: {
    type: String,
    default: null,
  },
});
</script>

<template>
  <!-- The remaining Quasar props - `props`, `auto-width`, `colspan` - travel by $attrs,
       which is what a primitive wrapping a Quasar component is for. -->
  <q-td
    :key="props.columnName"
    v-bind="$attrs"
  >
    <!-- @slot Cell content. -->
    <slot />
  </q-td>
</template>
